import React from 'react'
import PropTypes from 'prop-types'

import Popover from 'material-ui/Popover'
import Menu from 'material-ui/Menu'
import MenuItem from 'material-ui/MenuItem'
import FontIcon from 'material-ui/FontIcon'

export default class AllMaterialsHeader extends React.Component {

  static propTypes = {
    mode: PropTypes.string.isRequired,
    jobName: PropTypes.string,
    totalPrice: PropTypes.number,
    onModeSelectorChanged: PropTypes.func.isRequired,
    onRequestClose: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      openModeOptions: false
    }
  }

  handleCloseClicked = () => {
    this.props.onRequestClose()
  }

  getModeDisplay = () => {
    return this.props.mode === 'date'
      ? 'Days'
      : 'Workers'
  }

  handleModeClicked = event => {
    event.preventDefault()
    this.setState({
      openModeOptions: true,
      anchorElement: event.currentTarget
    })
  }

  handleModeOptionsClosed = () => {
    this.setState({
      openModeOptions: false
    })
  }

  handleModeSelection = selection => {
    this.props.onModeSelectorChanged(selection)
    this.setState({
      openModeOptions: false
    })
  }

  render() {
    return (
      <div style={styles.container}>
        <div style={styles.label}>All Materials in {this.props.jobName} - ${this.props.totalPrice.toFixed(2)}</div>
        <div style={styles.controls}>
          <div style={styles.mode} onClick={this.handleModeClicked}>
            <div style={styles.modeDisplay}>{this.getModeDisplay()}</div>
            <FontIcon className='material-icons' color='#fafafa'>
              keyboard_arrow_down
            </FontIcon>
            <Popover
              open={this.state.openModeOptions}
              anchorEl={this.state.anchorElement}
              anchorOrigin={{horizontal: 'middle', vertical: 'bottom'}}
              targetOrigin={{horizontal: 'left', vertical: 'bottom'}}
              onRequestClose={this.handleModeOptionsClosed}>
              <Menu>
                <MenuItem
                  key={1}
                  onTouchTap={() => this.handleModeSelection('date')}
                  primaryText='Date' />
                <MenuItem
                  key={2}
                  onTouchTap={() => this.handleModeSelection('worker')}
                  primaryText='Worker' />
              </Menu>
            </Popover>
          </div>
          <div style={styles.close} onClick={this.handleCloseClicked}>+</div>
        </div>
      </div>
    )
  }

}

const styles = {

  controls: {
    display: 'flex',
    flexDirection: 'row'
  },

  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#527da3',
    padding: 12,
    borderTopLeftRadius: 2,
    borderTopRightRadius: 2
  },

  label: {
    fontSize: 16,
    fontFamily: 'Roboto',
    color: '#fff'
  },

  close: {
    color: '#fff',
    fontSize: 24,
    transform: 'rotate(45deg)',
    cursor: 'pointer',
    fontFamily: 'x'
  },

  mode: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 6,
    paddingBottom: 6,
    borderRadius: 4,
    cursor: 'pointer',
    marginRight: 10
  },

  modeDisplay: {
    fontSize: 14,
    marginRight: 8,
    color: '#fafafa'
  }

}



// WEBPACK FOOTER //
// ./src/schedule/common/modules/materials/AllMaterialsHeader.js